import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/net-worth',
  component: () => import('../../routes/NetWorth.svelte'),
  card: {
    id: 'net-worth',
    title: 'Net Worth Calculator',
    description: 'Calculate your net worth by listing assets and liabilities. See category breakdowns and debt-to-asset ratio.',
    icon: 'account_balance_wallet',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/net-worth',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Net Worth Calculator – Assets Minus Liabilities | Free Financial Health Tool',
    description: 'Free net worth calculator. Add your assets and liabilities to calculate your total net worth, debt-to-asset ratio, and see detailed category breakdowns of your financial health.',
  },
};

export default meta;
